module.exports = __webpack_public_path__ + "static/media/RetailerTablet.a619f668.png";